import {Dropdown, Form, FormCheck} from "react-bootstrap";
import React, {Fragment, useEffect, useState} from "react";
import {connect} from "react-redux";
import {FilterItem, DataPointItem} from "./index";
import {
    setPreviousData,
    hideDataPoint,
    showDataPoint,
    hideAllDataPoint,
    showAllDataPoint
} from "../../../actions/DataActions";
import {FormGroup, Input, Label} from "reactstrap";

const FilterAvailableDataPoints = ({PlotData: {plot_data, hide_data, loading, active_plot}, Filters: {active_filter}, showAllDataPoint,hideAllDataPoint, showDataPoint, hideDataPoint, setPreviousData}) => {
    const [uniqueItems, SetItems] = useState([]);
    const [searchField, SetSearch] = useState('');
    const [hideAll, SetHideAll] = useState(true)
    const [style, setStyle] = useState({
        "overflowY": "auto",
        "height": "300px"
    });

    useEffect(() => {
        if (searchField !== '') {

            SetItems(uniqueItems.filter(dataPoint => dataPoint.includes(searchField.toUpperCase())))
        } else if (plot_data.hasOwnProperty(active_plot)) {

            SetItems([...new Set(plot_data[active_plot].map(x => x.nazwa_regionu))])
        }
    }, [searchField, plot_data]);
    
    useEffect(() => {
        if (uniqueItems.length === 0) {
            setStyle({
                "height": "0px"
            })
        } else {
            setStyle({
                "overflowY": "auto",
                "height": "300px"
            })
        }
    }, [uniqueItems]);
    
    useEffect(() => {
        for (const item in plot_data) {
            if (!hide_data.hasOwnProperty(item))
                setPreviousData({[item]: []});
        }
    }, [plot_data]);
    
    useEffect(() => {
        hideAllitems(true);
        SetHideAll(true)
    }, [active_filter])
    
    useEffect(() => {
        if (!hide_data.hasOwnProperty(active_plot))
            return;
        if( hide_data[active_plot].length >0)
            SetHideAll(false)
        else
            SetHideAll(true)
    }, [active_plot])

    const hideAllitems = (newSate) => {
        SetHideAll(newSate);
        if (newSate) {
            showAllDataPoint(active_plot)
        } else {
             hideAllDataPoint(uniqueItems, active_plot)
        }
    };

    return (
        <Dropdown style={{"opacity": "1"}} className={"ml-auto justify-content-end"}>
            {loading
                ?
                <Dropdown.Toggle block id="dropdown-basic" variant="" disabled={true} style={{backgroundColor:"#17728d"}} className={'wskButt m-0 btn-round'} outline>
                    Ładowanie Danych
                </Dropdown.Toggle>
                :
                <Dropdown.Toggle block id="dropdown-basic" variant="" style={{backgroundColor:"#17728d"}} className={'wskButt m-0 btn-round'}>
                    {hide_data.hasOwnProperty(active_plot) && hide_data[active_plot].length > 0 ? "Wybrano: " + (uniqueItems.length - hide_data[active_plot].length) + "/" + (uniqueItems.length) : "Regiony"}
                </Dropdown.Toggle>
            }

            <Dropdown.Menu>
                <Form.Group className={'p-1'} style={style}>
                    {hide_data.hasOwnProperty(active_plot) &&
                    <Form.Control className={'mb-1'} onChange={e => SetSearch(e.target.value)} value={searchField}
                                  placeholder={"Wyszukaj..."}/>}
                    <FormGroup style={{"backgroundColor": hideAll ? "#f8f9fa" : "white"}} check className='wskaznikiCheckBox'>
                        <Label for="hideAll" check>
                            <Input type="checkbox" name="hideAll" id="hideAll" onClick={() => hideAllitems(!hideAll)}
                                   checked={hideAll}/>
                            <span className="form-check-sign"/>
                            Zaznacz Wszystko</Label>
                    </FormGroup>
                    {hide_data.hasOwnProperty(active_plot) && uniqueItems.filter(dataPoint => !hide_data[active_plot].includes(dataPoint)).map((dataPoint) =>
                        <DataPointItem dataPoint={dataPoint}
                                       active_plot={active_plot}
                                       key={dataPoint}/>)
                    }
                    {hide_data.hasOwnProperty(active_plot) && uniqueItems.filter(dataPoint => hide_data[active_plot].includes(dataPoint)).map((dataPoint) =>
                        <DataPointItem dataPoint={dataPoint}
                                       active_plot={active_plot}
                                       key={dataPoint}/>)}
                </Form.Group>
            </Dropdown.Menu>
        </Dropdown>
    );
};


const mapStateToProps = state => ({
    PlotData: state.PlotData,
    Filters: state.Filters,

});
export default connect(mapStateToProps, {setPreviousData, hideAllDataPoint,hideDataPoint, showAllDataPoint,showDataPoint})(FilterAvailableDataPoints)